import { FormattedMessage } from "react-intl";

import { DEFAULT_VALUES, useLocalizedHref } from "@/libraries/web-framework";
const Templates = () => {
    const localizedHref = useLocalizedHref("/software/confluence/templates");
    return (
        <div>
            <p>
                <FormattedMessage
                    id="ConfluencePricingPageTeam24.features.templates.content.body"
                    defaultMessage="Get started quickly by using the <a>template library</a>. From product requirement documents to marketing plans, there’s a template that’s perfect fit for your project."
                    values={{
                        ...DEFAULT_VALUES,
                        a: (chunks) => (
                            <a
                                data-event="clicked"
                                data-event-component="linkButton"
                                data-product-key="confluence"
                                data-track-event="ConfluencePricingPageTeam24.templates"
                                data-event-container="ConfluencePriceFinderTeam24"
                                data-label-english="template libary"
                                href={localizedHref}
                            >
                                {chunks}
                            </a>
                        )
                    }}
                />
            </p>
        </div>
    );
};
export default Templates;
